import { render, staticRenderFns } from "./DashboardChangelog.vue?vue&type=template&id=ce4fde02&scoped=true"
import script from "./DashboardChangelog.vue?vue&type=script&lang=js"
export * from "./DashboardChangelog.vue?vue&type=script&lang=js"
import style0 from "./DashboardChangelog.vue?vue&type=style&index=0&id=ce4fde02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4fde02",
  null
  
)

export default component.exports